module.exports = __webpack_public_path__ + "o.no1.e7c598e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/o.no1.jpg
// module id = ZcMs
// module chunks = 0